import React from "react";
import {
    Box,
    Paper,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@mui/material";

const headerSx = { "& .MuiTableCell-root": { color: "primary.dark", fontSize: "0.85rem" } };

const CrewResourceTable = ({ data = [] }) => {
    return (
        <Box display="flex" flexDirection="column" gap={2}>
            <Paper sx={{ px: 2, pt: 1 }}>
                <Table size="small">
                    <TableHead sx={headerSx}>
                        <TableRow>
                            <TableCell>Rank</TableCell>
                            <TableCell align="right">Demand</TableCell>
                            <TableCell align="right">Supply</TableCell>
                            <TableCell align="right">Gap</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data?.map((row) => {
                            const isNegative = row.gap < 0;
                            const isPositive = row.gap > 0;
                            return (
                                <TableRow key={row.rank}>
                                    <TableCell>{row.rank}</TableCell>
                                    <TableCell align="right">
                                        {row.demand?.toLocaleString?.() ?? 0}
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.supply?.toLocaleString?.() ?? 0}
                                    </TableCell>
                                    <TableCell
                                        align="right"
                                        sx={{
                                            fontWeight: 600,
                                            color: isNegative ? "error.main"
                                                : isPositive ? "success.main"
                                                : "text.primary",
                                        }}
                                    >
                                        {row.gap?.toLocaleString?.() ?? 0}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Paper>
        </Box>
    );
};

export default CrewResourceTable;
